import React, { useEffect, useState } from "react"
import axios from "axios"

const API = process.env.REACT_APP_API_URL || "http://localhost:3001/api"

const TIPOS = [
  {id:"gps", label:"GPS Básico"},
  {id:"telemetria", label:"Telemetria"},
  {id:"video", label:"Vídeo Telemetria"},
  {id:"tag", label:"Tag Rastreamento"},
  {id:"outro", label:"Outro"},
]

const FORM_VAZIO = { nome:"", tipo:"gps", valor:"", custo_instalacao:"", custo_desinstalacao:"", descricao:"" }

const fmtMoeda = (v:any) => v ? `R$ ${parseFloat(v).toFixed(2).replace(".",",")}` : "—"

export default function Planos() {
  const [dados, setDados]   = useState<any[]>([])
  const [modal, setModal]   = useState(false)
  const [editando, setEditando] = useState<any>(null)
  const [form, setForm]     = useState<any>(FORM_VAZIO)
  const [loading, setLoading] = useState(true)

  const carregar = async () => {
    try {
      const r = await axios.get(`${API}/planos`)
      setDados(r.data)
    } catch {} finally { setLoading(false) }
  }

  useEffect(()=>{ carregar() },[])

  const abrirNovo = () => { setEditando(null); setForm(FORM_VAZIO); setModal(true) }
  const abrirEditar = (p:any) => {
    setEditando(p)
    setForm({ nome:p.nome, tipo:p.tipo, valor:p.valor,
      custo_instalacao:p.custo_instalacao||"", custo_desinstalacao:p.custo_desinstalacao||"",
      descricao:p.descricao||"" })
    setModal(true)
  }

  const salvar = async () => {
    if (!form.nome || !form.valor) return alert("Nome e valor são obrigatórios")
    try {
      if (editando) await axios.put(`${API}/planos/${editando.id}`, form)
      else await axios.post(`${API}/planos`, form)
      setModal(false); carregar()
    } catch(e:any) { alert(e.response?.data?.erro||"Erro ao salvar") }
  }

  const desativar = async (id:string, ativo:boolean) => {
    try {
      await axios.put(`${API}/planos/${id}`, { ativo: !ativo })
      carregar()
    } catch {}
  }

  return (
    <div style={{padding:24,height:"100%",overflowY:"auto"}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20}}>
        <div>
          <h2 style={{fontSize:20,fontWeight:700}}>📋 Planos de Rastreamento</h2>
          <p style={{fontSize:13,color:"#64748b"}}>Configure os planos, valores mensais e custos de instalação/desinstalação</p>
        </div>
        <button className="btn btn-primary" onClick={abrirNovo}>+ Novo plano</button>
      </div>

      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(280px,1fr))",gap:16}}>
        {loading ? <div style={{color:"#64748b"}}>Carregando...</div>
        : dados.map((p:any)=>(
          <div key={p.id} className="card" style={{opacity:p.ativo?1:0.5}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:12}}>
              <div>
                <div style={{fontWeight:700,fontSize:15,color:"#f1f5f9"}}>{p.nome}</div>
                <div style={{fontSize:11,color:"#64748b",marginTop:2}}>
                  {TIPOS.find(t=>t.id===p.tipo)?.label||p.tipo}
                </div>
              </div>
              <span style={{fontSize:10,padding:"2px 8px",borderRadius:10,
                background:p.ativo?"#14532d":"#1e293b",color:p.ativo?"#4ade80":"#64748b"}}>
                {p.ativo?"Ativo":"Inativo"}
              </span>
            </div>

            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:8,marginBottom:12}}>
              <div style={{background:"#0d1b2e",borderRadius:8,padding:"8px 10px",textAlign:"center"}}>
                <div style={{fontSize:10,color:"#475569",marginBottom:2}}>Mensal</div>
                <div style={{fontSize:13,fontWeight:700,color:"#22c55e"}}>{fmtMoeda(p.valor)}</div>
              </div>
              <div style={{background:"#0d1b2e",borderRadius:8,padding:"8px 10px",textAlign:"center"}}>
                <div style={{fontSize:10,color:"#475569",marginBottom:2}}>Instalação</div>
                <div style={{fontSize:13,fontWeight:700,color:"#0ea5e9"}}>{fmtMoeda(p.custo_instalacao)}</div>
              </div>
              <div style={{background:"#0d1b2e",borderRadius:8,padding:"8px 10px",textAlign:"center"}}>
                <div style={{fontSize:10,color:"#475569",marginBottom:2}}>Desinstalação</div>
                <div style={{fontSize:13,fontWeight:700,color:"#f59e0b"}}>{fmtMoeda(p.custo_desinstalacao)}</div>
              </div>
            </div>

            {p.descricao && <div style={{fontSize:11,color:"#64748b",marginBottom:12}}>{p.descricao}</div>}

            <div style={{display:"flex",gap:8}}>
              <button className="btn btn-ghost" style={{flex:1,fontSize:12}} onClick={()=>abrirEditar(p)}>✏️ Editar</button>
              <button className="btn btn-ghost" style={{fontSize:12,color:p.ativo?"#f87171":"#4ade80"}}
                onClick={()=>desativar(p.id,p.ativo)}>
                {p.ativo?"🔒 Desativar":"✅ Ativar"}
              </button>
            </div>
          </div>
        ))}
      </div>

      {modal && (
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.6)",zIndex:1000,
          display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
          <div className="card" style={{width:"100%",maxWidth:480}}>
            <div style={{display:"flex",justifyContent:"space-between",marginBottom:20}}>
              <h3>{editando?"✏️ Editar plano":"📋 Novo plano"}</h3>
              <button className="btn btn-ghost" style={{padding:"4px 8px"}} onClick={()=>setModal(false)}>✕</button>
            </div>

            <div className="form-grid">
              <div className="form-group full">
                <label>Nome do plano *</label>
                <input value={form.nome} onChange={e=>setForm({...form,nome:e.target.value})}
                  placeholder="Ex: GPS Básico, Telemetria Plus..." />
              </div>
              <div className="form-group">
                <label>Tipo</label>
                <select value={form.tipo} onChange={e=>setForm({...form,tipo:e.target.value})}>
                  {TIPOS.map(t=><option key={t.id} value={t.id}>{t.label}</option>)}
                </select>
              </div>
              <div className="form-group">
                <label>💰 Valor mensal *</label>
                <div style={{position:"relative"}}>
                  <span style={{position:"absolute",left:10,top:"50%",transform:"translateY(-50%)",color:"#64748b",fontSize:13}}>R$</span>
                  <input type="number" value={form.valor} step="0.01" min="0"
                    onChange={e=>setForm({...form,valor:e.target.value})}
                    placeholder="0,00" style={{paddingLeft:32}} />
                </div>
              </div>
              <div className="form-group">
                <label>🔧 Custo de instalação</label>
                <div style={{position:"relative"}}>
                  <span style={{position:"absolute",left:10,top:"50%",transform:"translateY(-50%)",color:"#64748b",fontSize:13}}>R$</span>
                  <input type="number" value={form.custo_instalacao} step="0.01" min="0"
                    onChange={e=>setForm({...form,custo_instalacao:e.target.value})}
                    placeholder="0,00" style={{paddingLeft:32}} />
                </div>
                <div style={{fontSize:10,color:"#475569",marginTop:3}}>Cobrado na 1ª fatura</div>
              </div>
              <div className="form-group">
                <label>🔓 Custo de desinstalação</label>
                <div style={{position:"relative"}}>
                  <span style={{position:"absolute",left:10,top:"50%",transform:"translateY(-50%)",color:"#64748b",fontSize:13}}>R$</span>
                  <input type="number" value={form.custo_desinstalacao} step="0.01" min="0"
                    onChange={e=>setForm({...form,custo_desinstalacao:e.target.value})}
                    placeholder="0,00" style={{paddingLeft:32}} />
                </div>
                <div style={{fontSize:10,color:"#475569",marginTop:3}}>Pré-preenchido no modal de desinstalação</div>
              </div>
              <div className="form-group full">
                <label>Descrição</label>
                <input value={form.descricao} onChange={e=>setForm({...form,descricao:e.target.value})}
                  placeholder="Detalhes do plano..." />
              </div>
            </div>

            <div style={{display:"flex",gap:8,justifyContent:"flex-end",marginTop:16}}>
              <button className="btn btn-ghost" onClick={()=>setModal(false)}>Cancelar</button>
              <button className="btn btn-primary" onClick={salvar}>💾 Salvar plano</button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
